module.exports = __webpack_public_path__ + "img/Malaysia2.a5b62585.png";